import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/auth/_services';
import { User } from 'src/app/auth/_models';
import { Ng7BootstrapBreadcrumbService } from 'ng7-bootstrap-breadcrumb';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  currentUser: User;

  constructor(
    private ng7BootstrapBreadcrumbService: Ng7BootstrapBreadcrumbService,
    private authenticationService: AuthenticationService
    )
   {

    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);

   }

  ngOnInit() {
      const breadcrumbs = [
        { label: 'Sesc Digital', url: '/', params: [] },
        { label: 'Home', url: '', params: [] },]
      
      this.ng7BootstrapBreadcrumbService.updateBreadcrumb(breadcrumbs);
    }

    
  }
